export function captureRequestIdentity(getters) {
  return { token: getters.getToken, company: String(getters.getActiveCompanyId ?? ''), role: getters.getLoggedAs };
}

export function sameRequestIdentity(first, second) {
  return Boolean(first && second) && first.token === second.token
    && String(first.company ?? '') === String(second.company ?? '') && first.role === second.role;
}
